import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { Model } from "appworks/model/model";
import { RecordBuilder } from "appworks/server/builders/record-builder";
import { Services } from "appworks/services/services";
import { FeatureFlag, gamevyModel } from "gamevy/gamevy-model";
import { GamevyConfigResponseSchema, GamevyFeatureFlagsSchema } from "gamevy/integration/schema/gamevy-config-response-schema";
import { gambleModel } from "slotworks/model/gamble/gamble-model";

export class GamevyPartnerConnectConfigRecordBuilder implements RecordBuilder {

    public id: string = "GamevyPartnerConnectConfigRecordBuilder";

    public filter(request: any, config: any): boolean {
        return config?.settings !== undefined;
    }

    public build(gameplay: Gameplay, request: any, config: any): Record[] {
        const configResponse: GamevyConfigResponseSchema = config?.settings?.slotConfig?.Config;
        if (configResponse) {

            if (configResponse.gambleChoices) {
                gambleModel.setDefaults(configResponse.gambleChoices.colours.concat(configResponse.gambleChoices.suits));
            }

            const featureFlags: GamevyFeatureFlagsSchema = {
                autoSpinEnabled:        !config.settings.isAutoSpinsDisabled,
                autoSpinLimit:          config.settings.hasLossLimit,
                autoSpinLimitOptions:   config.settings.autoplayLevels,
                turboAvailable:         !Boolean(config.settings.minimalSpinningTime),
                spinDelays:             [],
                speedLimited:           config.settings.speedLimited,
                sessionTimerEnabled:    config.settings.sessionTimerEnabled
            };

            for (const key in featureFlags) {
                if (featureFlags[key] !== undefined) {
                    gamevyModel.featureFlags.set(key as FeatureFlag, featureFlags[key]);
                }
            }

            this.setJuriRequirements(featureFlags);

            gamevyModel.version = configResponse.version;
        }

        return [];
    }

    protected setJuriRequirements(featureFlags: GamevyFeatureFlagsSchema) {
        if (!featureFlags) {
            return;
        }

        if (featureFlags.autoSpinEnabled !== undefined) {
            Services.jurisdiction.setAutoplayEnabled(featureFlags.autoSpinEnabled);
        }
        const settings = Model.read().settings;
        settings.spaceToSpin = featureFlags.autoSpinEnabled || false;
        Model.write({ settings });

        if (featureFlags.autoSpinLimit !== undefined) {
            Services.jurisdiction.setUnlimitedAutoplayEnabled(!featureFlags.autoSpinLimit);
        }

        // Comes back as "false" or undefined, so check truthy
        if (featureFlags.autoSpinLimitOptions) {
            Services.jurisdiction.setAutoplayLimits(featureFlags.autoSpinLimitOptions);
        }

        if (featureFlags.turboAvailable !== undefined) {
            Services.jurisdiction.setQuickSpinEnabled(featureFlags.turboAvailable);
        }

        if (featureFlags?.spinDelays.length) {
            const delays = featureFlags.spinDelays;
            delays.sort((a, b) => b.minBet - a.minBet);
            Services.jurisdiction.setMinimumSpinTimes(delays.map((delay) => ({ minBet: delay.minBet, delayMs: delay.delayInSeconds * 1000 })));
        }

        if (featureFlags.speedLimited !== undefined) {
            Services.jurisdiction.setSpinSkippingEnabled(!featureFlags.speedLimited);
        }

        if (featureFlags.sessionTimerEnabled !== undefined) {
            // Currently just one boolean for the both of them, but wanted to make it clear that this is currently intended
            Services.jurisdiction.setElapsedTimeEnabled(featureFlags.sessionTimerEnabled);
            Services.jurisdiction.setNetPositionEnabled(featureFlags.sessionTimerEnabled);
        }
    }
}

export const gamevyPartnerConnectConfigRecordBuilder = new GamevyPartnerConnectConfigRecordBuilder();
